import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useCapacitorBackButton = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      const handler = App.addListener('backButton', ({ canGoBack }) => {
        if (
          window.location.pathname === '/' ||
          window.location.pathname === '/home'
        ) {
          App.exitApp();
        } else {
          navigate(-1);
        }
      });

      return () => {
        handler.remove();
      };
    }
  }, [navigate]);
};

export default useCapacitorBackButton;
